// @ts-nocheck
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'
import useWindowScrollPosition from 'helpers/useWindowScrollPosition'

import Document from 'js/components/Document'
import { Container } from 'js/components/Grid'
import { useSiteStore } from 'js/lib/stores'
import FeedView from 'js/page/Widget/components/Feed/FeedView'

import { EVENTS_GROUP_LIST_WRAPPER } from './GroupList.queries'
import type { EventsGroupListWrapperQuery } from './GroupList.queries.generated'

type Props = {
    data: EventsGroupListWrapperQuery
}

const EventsGroupInnerPage = ({ data }: Props) => {
    const { t } = useTranslation()
    const { groupGuid } = useParams()
    const eventTiles = useSiteStore(({ site }) => site.eventTiles)

    const guid = `${groupGuid}-events`
    useWindowScrollPosition(guid)

    const { entity, site } = data

    const settings = {
        showTagFilter: site?.pageTagFilters.showAllTagCategories,
        showTagCategories: site?.pageTagFilters.showTagCategories,
        typeFilter: ['event'],
        showEventFilter: true,
        itemView: eventTiles ? 'tile' : 'list',
        itemCount: 10,
    }

    return (
        <>
            <Document
                title={t('entity-event.name', { count: 2 })}
                containerTitle={entity?.name}
            />
            <Container size={eventTiles ? 'large' : 'tiny'}>
                <FeedView
                    guid={guid}
                    groupGuid={groupGuid}
                    settings={settings}
                />
            </Container>
        </>
    )
}

// First load data, otherwise useWindowScrollPosition and FeedView won't work properly
export const EventsGroupPage = () => {
    const { groupGuid } = useParams()
    const { data, loading } = useQuery(EVENTS_GROUP_LIST_WRAPPER, {
        variables: {
            guid: groupGuid,
        },
    })

    if (loading) {
        return null
    }
    return <EventsGroupInnerPage data={data} />
}
